import { Button, Dialog } from '@material-ui/core';
import React, { memo, useCallback, useState } from 'react';
import { useBreakpoints } from 'utils/use-breakpoints';
import { CustomiseASBVs } from './customise-asbvs';
import { CustomiseASBVsButtonProps } from './customise-asbvs-button-props';

/**
 * A standard button to customise ASBVs. This acts as the entry point
 * to the Customise ASBVs modal.
 */
export const CustomiseASBVsButton: React.FC<CustomiseASBVsButtonProps> = memo((props) => {
  const {
    disabled,
    onSave,
    hideNonPercentileASBVS = false,
  } = props;

  const [open, setOpen] = useState(false);
  const { phone } = useBreakpoints();

  const cancel = useCallback(() => setOpen(false), []);
  const save = useCallback(() => {
    setOpen(false);
    if (onSave) {
      onSave();
    }
  }, [onSave]);

  return (
    <>
      <Button
        fullWidth
        variant="outlined"
        disabled={disabled}
        onClick={() => setOpen(true)}
      >
        Customise ASBVS
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        fullScreen={phone}
        maxWidth="lg"
      >
        <CustomiseASBVs
          onCancel={cancel}
          onSave={save}
          hideNonPercentileASBVS={hideNonPercentileASBVS}
        />
      </Dialog>
    </>
  );
});
